import React from "react";
import T from "prop-types";
import {
  Modal,
  Close,
  Header,
  Body,
  Footer
} from "MODULES/shared/components/Modal";

export function NotCompletelyShippedWarning({ close, warningOpen }) {
  return (
    <Modal open={warningOpen} close={close} dialogClass="modal-sm">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Invalid Action.</h4>
      </Header>
      <Body>
        <div className="alert alert-warning margin-bottom-none">
          <div className="media">
            <div className="media-left">
              <i className="fa fa-lg fa-warning text-warning" />
            </div>
            <div className="media-body">
              <strong>Partially Shipped</strong> This sales item has been{" "}
              partially shipped. Completely ship in order to proceed with this
              action.
            </div>
          </div>
        </div>
      </Body>
      <Footer>
        <button type="submit" className="btn btn-primary" onClick={close}>
          OK
        </button>
      </Footer>
    </Modal>
  );
}

NotCompletelyShippedWarning.propTypes = {
  close: T.func.isRequired,
  warningOpen: T.bool.isRequired
};

export default NotCompletelyShippedWarning;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/NotCompletelyShippedWarning.jsx